module.exports = __webpack_public_path__ + "static/img/icon_map@2x.4807dd5.png";